import { ExternalBookingStatus } from "./Booking";

export class BookingExternalListRow {
    id: number;
    tspBookingId: number;
    tspId: number;
    bookingLabel: string;
    priceIncVatCents: number;
    newPriceIncVatCents: number;
    status: ExternalBookingStatus;
    bookFromDatetime: Date;
    bookToDatetime: Date;
    itemId: number|null;
    createdAt: Date;
    userId: number|null;
    userUsername: string|null;
    userLastName: string|null;
    userFirstName: string|null;
    pickupHubId: number|null;
    pickupHubName: string|null;
    userFeedbackId: number|null;

    constructor(data) {
        this.id = data.id;
        this.tspBookingId = data.tspBookingId;
        this.tspId = data.tspId;
        this.bookingLabel = data.bookingLabel;
        this.priceIncVatCents = data.priceIncVatCents;
        this.newPriceIncVatCents = data.newPriceIncVatCents;
        this.status = data.status;
        this.bookFromDatetime = new Date(data.bookFromDatetime);
        this.bookToDatetime = new Date(data.bookToDatetime);
        this.itemId = data.itemId;
        this.createdAt = new Date(data.createdAt);
        this.userId = data.userId;
        this.userUsername = data.userUsername;
        this.userLastName = data.userLastName;
        this.userFirstName = data.userFirstName;
        this.pickupHubId = data.pickupHubId;
        this.pickupHubName = data.pickupHubName;
        this.userFeedbackId = data.userFeedbackId;
    }

  /// Check if booking is currently late
  get isLate(): boolean {
    // should match implementation of BookingExternal.isLate
    return [
      ExternalBookingStatus.LEASE_STARTED.toUpperCase(),
      ExternalBookingStatus.LEASE_EXTENDED.toUpperCase()
    ].indexOf(this.status.toUpperCase()) !== -1 && this.bookToDatetime < (new Date());
  }

  /// Get the total price paid for the booking in Kr, including VAT
  get totalPriceInKr(): number {
    // Convert from cents to kr
    if(!this.newPriceIncVatCents){
      return this.priceIncVatCents / 100;
    }
    return (this.newPriceIncVatCents) / 100;
  }
}